(ns ductile.ui.load-builder-v2.effects
  (:require [cljs.reader :as reader]
            [clojure.string :as str]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.load-builder.overview-map :as overview-map]
            [nextjournal.clerk.render.hooks :as hooks]))

(defn use-popout-cleanup! [{:keys [popup-mode? dispatch!]}]
  (hooks/use-effect
   (fn []
     (when-not popup-mode?
       (let [timer (js/setInterval
                    (fn []
                      (dispatch! {:event :popouts/update
                                  :f (fn [m]
                                       (let [m' (into {}
                                                      (filter (fn [[_ w]] (and w (not (.-closed w)))))
                                                      m)]
                                         (if (= m m') m m')))}))
                    500)]
         #(js/clearInterval timer))))
   [popup-mode?]))

(defn use-message-listener! [{:keys [sid popup-mode? popout-panel transport->vehicle-ids popouts vehicle-id->transport handle-message!]}]
  (hooks/use-effect
   (fn []
     (let [handler (fn [^js e]
                     (let [message (js->clj (.-data e) :keywordize-keys true)]
                       (handle-message! message (.-source e))))]
       (js/window.addEventListener "message" handler)
       #(js/window.removeEventListener "message" handler)))
   [sid popup-mode? popout-panel transport->vehicle-ids popouts vehicle-id->transport]))

(defn use-popup-pending-ops! [{:keys [popup-mode? sid window-id state dispatch! now-ms enqueue-popup-op! push-trace!]}]
  (hooks/use-effect
   (fn []
     (when popup-mode?
       (let [timer (js/setInterval
                    (fn []
                      (let [now (now-ms)
                            threshold 1500]
                        (doseq [[op-id {:keys [submitted-at queued?] :as op-data}] (:pending-ops @state)]
                          (when (and submitted-at
                                     (not queued?)
                                     (> (- now submitted-at) threshold))
                            (enqueue-popup-op! (assoc op-data :origin-window-id window-id))
                            (push-trace! sid {:kind :timeout-queued
                                              :where :popup
                                              :window-id window-id
                                              :op-id op-id
                                              :op (:op op-data)})
                            (dispatch! {:event :popup/pending-assoc
                                        :op-id op-id
                                        :op-data (assoc op-data :queued? true)})))))
                    200)]
         #(js/clearInterval timer))))
   [popup-mode? sid window-id]))

(defn use-popup-pending-gc! [{:keys [popup-mode? dispatch! now-ms]}]
  (hooks/use-effect
   (fn []
     (when popup-mode?
       (let [timer (js/setInterval
                    (fn []
                      (let [now (now-ms)
                            grace-ms 1200]
                        (dispatch! {:event :popup/pending-rewrite
                                    :f (fn [m]
                                         (into {}
                                               (remove (fn [[_ {:keys [acked-at]}]]
                                                         (and acked-at
                                                              (> (- now acked-at) grace-ms))))
                                               m))})))
                    250)]
         #(js/clearInterval timer))))
   [popup-mode?]))

(defn use-main-ops-drain! [{:keys [popup-mode? sid state window-id transport-id->wire apply-shared-op! post-op! popouts now-ms ops-key push-trace!]}]
  (hooks/use-effect
   (fn []
     (when-not popup-mode?
       (let [k (ops-key sid)
             timer (js/setInterval
                    (fn []
                      (when-let [raw (js/localStorage.getItem k)]
                        (when-not (str/blank? raw)
                          (try
                            (let [ops (or (reader/read-string raw) [])]
                              (doseq [{:keys [id ts op vehicle-ids transport-id name draft-id origin-window-id] :as op-data} ops]
                                (push-trace! sid {:kind :queue-apply
                                                  :where :main
                                                  :window-id window-id
                                                  :op-id id
                                                  :op op})
                                (apply-shared-op! {:id id
                                                   :ts ts
                                                   :op op
                                                   :vehicle-ids vehicle-ids
                                                   :transport-id transport-id
                                                   :name name
                                                   :draft-id draft-id})
                                (doseq [w (vals (:popouts @state))]
                                  (post-op! w sid (or id (str (random-uuid)))
                                            (cond-> (dissoc op-data :id :ts)
                                              transport-id (update :transport-id transport-id->wire)
                                              true (assoc :origin-window-id (or origin-window-id window-id))))))
                              (js/localStorage.removeItem k))
                            (catch :default _
                              (js/localStorage.removeItem k))))))
                    150)]
         #(js/clearInterval timer))))
   [popup-mode? sid popouts now-ms]))

(defn use-loads-sync! [{:keys [loads fahrzeuge draft-transports dispatch!]}]
  (hooks/use-effect
   (fn []
     (dispatch! {:event :transport/sync-from-loads
                 :loads loads
                 :fahrzeuge fahrzeuge}))
   [loads fahrzeuge draft-transports]))

(defn use-layout-persistence! [{:keys [layout]}]
  (hooks/use-effect
   (fn []
     (deframe/localstorage-assoc! :ductile.ui.load-builder-v2/layout layout))
   [layout]))

(defn use-enforce-vehicles-panel! [{:keys [dispatch!]}]
  (hooks/use-effect
   (fn []
     (dispatch! {:event :layout/update
                 :f #(update % :hidden disj :vehicles)}))
   []))

(defn use-map-resize-on-layout! [{:keys [layout popouts]}]
  (hooks/use-effect
   (fn []
     (let [raf1 (js/requestAnimationFrame
                 (fn []
                   (when-some [the-map @overview-map/!the-map]
                     (.resize the-map))))
           raf2 (js/requestAnimationFrame
                 (fn []
                   (js/requestAnimationFrame
                    (fn []
                      (when-some [the-map @overview-map/!the-map]
                        (.resize the-map))))))]
       #(do
          (js/cancelAnimationFrame raf1)
          (js/cancelAnimationFrame raf2))))
   [layout popouts]))

(defn use-heartbeat! [{:keys [popup-mode? sid heartbeat-key now-ms]}]
  (hooks/use-effect
   (fn []
     (when-not popup-mode?
       (let [hb-key (heartbeat-key sid)
             timer (js/setInterval
                    (fn []
                      (js/localStorage.setItem hb-key (str (now-ms))))
                    1000)]
         #(js/clearInterval timer))))
   [popup-mode? sid]))

(defn use-shared-state-sync! [{:keys [popup-mode?
                                      sid
                                      layout
                                      draft-transports
                                      draft-order
                                      transport->vehicle-ids
                                      transport->waypoint-settings
                                      staging-ids
                                      focused-transport-id
                                      shared-state-key
                                      heartbeat-key
                                      now-ms
                                      state
                                      !last-shared-focused-id
                                      dispatch!
                                      popout-panel
                                      compute-focused-route!
                                      clear-focused-route!
                                      reconcile-from-shared!]}]
  (hooks/use-effect
   (fn []
     (when-not popup-mode?
       (let [shared {:layout layout
                     :draft-transports draft-transports
                     :draft-order draft-order
                     :transport->vehicle-ids transport->vehicle-ids
                     :transport->waypoint-settings transport->waypoint-settings
                     :staging-ids staging-ids
                     :focused-transport-id focused-transport-id}
             key (shared-state-key sid)]
         (js/localStorage.setItem key (pr-str shared)))))
   [popup-mode? sid layout draft-transports draft-order transport->vehicle-ids transport->waypoint-settings staging-ids focused-transport-id])
  (hooks/use-effect
   (fn []
     (when popup-mode?
       (let [key (shared-state-key sid)
             hb-key (heartbeat-key sid)
             timer (js/setInterval
                    (fn []
                      (when-let [raw (js/localStorage.getItem key)]
                        (try
                          (let [{:keys [layout draft-transports draft-order transport->vehicle-ids transport->waypoint-settings staging-ids focused-transport-id]} (reader/read-string raw)]
                            (swap! state merge {:layout layout
                                                :draft-transports draft-transports
                                                :draft-order (or draft-order [])
                                                :transport->vehicle-ids transport->vehicle-ids
                                                :transport->waypoint-settings (or transport->waypoint-settings {})
                                                :staging-ids staging-ids})
                            (when (not= focused-transport-id (.-current !last-shared-focused-id))
                              (set! (.-current !last-shared-focused-id) focused-transport-id)
                              (if focused-transport-id
                                (if (= popout-panel :map)
                                  (compute-focused-route! focused-transport-id transport->vehicle-ids)
                                  (dispatch! {:event :route/set-focused-id
                                              :transport-id focused-transport-id}))
                                (clear-focused-route!)))
                            (reconcile-from-shared!))
                          (catch :default _ nil)))
                      (let [hb (some-> (js/localStorage.getItem hb-key) js/parseFloat)
                            stale? (or (nil? hb) (> (- (now-ms) hb) 5000))]
                        (when stale?
                          (js/window.close)
                          (dispatch! {:event :ui/set-disconnected
                                      :disconnected? true}))))
                    500)]
         #(js/clearInterval timer))))
   [popup-mode? sid popout-panel]))

(defn use-escape-reset! [{:keys [dispatch!]}]
  (hooks/use-effect
   (fn []
     (let [handler (fn [^js e]
                     (when (= "Escape" (.-key e))
                       (dispatch! {:event :menu/clear})
                       (dispatch! {:event :selection/clear})))]
       (js/window.addEventListener "keydown" handler)
       #(js/window.removeEventListener "keydown" handler)))
   []))
